import React, { Suspense } from 'react';
import CreateContainer from "./CreateContainer";

const CreateStore = (props) => {
    return (
        <CreateContainer {...props} />
    );
};

export default CreateStore;